
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

import SelectBox   from '../SelectBox';
import EventSearch from '../EventSearch';
import Label       from '../Label';

class EventFilterBar extends React.Component {

    _sortChanged(event) {

        this.props.sortChanged(event.target.value);
    }

    _moduleFilterChanged(event) {

        this.props.moduleFilterChanged(event.target.value);
    }

    _eventTypeFilterChanged(event) {

        this.props.eventTypeFilterChanged(event.target.value);
    }

    render() {

        return (
            <div styleName="bar">

                <h4 className={style['result-summary-heading']}>Programme Selection</h4>

                <span styleName="result-summary">
                    { this.props.eventCount } Courses and Conferences are available for booking
                </span>

                <div styleName="search-wrapper">
                    <EventSearch onSearch={ this.props.onSearch } />
                </div>

                <div styleName="filter-options-wrapper">

                    <div styleName="filter-option">

                        <div styleName="label-wrapper">
                            <Label>Filter by</Label>
                        </div>

                        <span styleName="select-wrapper--sort">

                            <SelectBox value={ this.props.filterByEventType }
                                       onChange={ this._eventTypeFilterChanged.bind(this) }
                                       style={{color: '#ffffff'}}>

                                <option value="0">All Event Types</option>
                                <option value="classroom">Courses</option>
                                <option value="conference">Conferences</option>
                                <option value="webinar">Webinar</option>

                            </SelectBox>

                        </span>

                    </div>

                    <div styleName="filter-option">

                        <span styleName="select-wrapper--sort">

                            <SelectBox value={ this.props.filterByModuleId }
                                       onChange={ this._moduleFilterChanged.bind(this) }
                                       style={{color: '#ffffff'}}>

                                <option value="0">All Subjects</option>

                                {
                                    this.props.modules.map((module, index) => {

                                        return (
                                            <option key={ index } value={ module.id }>
                                                { module.name }
                                            </option>
                                        );
                                    })
                                }

                            </SelectBox>

                        </span>

                    </div>

                    <div styleName="filter-option">

                        <div styleName="label-wrapper">
                            <Label>Sort by</Label>
                        </div>

                        <span styleName="select-wrapper--sort">
                            
                            <SelectBox value={ this.props.sortBy }
                                       onChange={ this._sortChanged.bind(this) }
                                       style={{color: '#ffffff'}}>
                                
                                <option value="date">Date</option>
                                <option value="course">Course</option>
                                
                            </SelectBox>
                            
                        </span>

                    </div>

                </div>

            </div>
        );
    }
}

export default CSSModules(EventFilterBar, style);


// WEBPACK FOOTER //
// ./components/EventFilterBar/index.js